<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">服务列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 顶部banner 开始 -->
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
    <div class="page_top serviceList_top">
      <div class="serviceListsearch_box">
        <div class="serviceListsearch_left">
          <img class="serviceListsearch_icon" src="/static/sousuoicon.png" />
          <input class="serviceListsearch_input" placeholder="请输入您要搜索的商品" v-model="inputkeyword" />
        </div>
        <div class="serviceListsearch_text" @click="search()">搜索</div>
      </div>
      <!-- <van-cell is-link @click="showPopup"> -->
      <div class="serviceList_dingwei" @click="buttonClicked ? '' : showMask1()">
        <img src="/static/whiteLocate.png" class="serviceList_dingweiicon" />
        <div class="serviceList_dingweiname">{{ city ? city : '定位中...' }}</div>
      </div>
      <!-- </van-cell> -->
    </div>
    <!-- 顶部banner 结束 -->
    <!-- 服务列表 开始 -->
    <!-- 暂无信息  开始 -->
    <div class="page_none serviceList_none" v-if="loads && (!storeList || storeList.length == 0)">
      <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
    </div>
    <!-- 暂无信息  结束 @click="scrolltolower()"-->
    <div class="serviceList_List" v-else="storeList !==undefined && storeList !==null">
      <div class="serviceList_box" v-for="(item, index) in storeList " :key="item.storeKey" @click="toDesc(item.id)"
        :id="item.toDesc">
        <div class="serviceList_imgbox">
          <img class="serviceList_img" :src="item.thumb_url" lazy-load="true" />
        </div>
        <div class="serviceList_detail">
          <div class="serviceList_name">{{ item.name }}</div>
          <div class="serviceList_address">地址：{{ item.address }}</div>
          <div class="serviceList_juli">
            <img class="serviceList_juliicon" src="/static/newprojecticon/juliicon.png" />
            <div class="serviceList_julinum">{{ item.distance_str }}</div>
          </div>
        </div>
      </div>
      <div class="bottom-last" v-if="storeFlag" @click="getmore()">查看更多</div>
      <div class="bottom-last" v-if="!storeFlag">到底了~</div>
    </div>
    <!-- 服务列表 结束 -->

    <!-- 弹出层 开始 -->
    <!-- <van-popup v-model="show" position="top" :style="{ height: '30%' }">内容</van-popup> -->
    <transition name="fade">
      <div class="maskPanel" v-if="!isMaskHidden" @click=" buttonClicked ? '' : showMask1()" id="showMask">
        <div class="maskCont">
          <div class="maskdiv" v-for="(item, index) in cityList" :key="index" @click="tap(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </transition>
    <!-- 弹出层 结束 -->
    <!-- </van-pull-refresh> -->
  </div>
</template>

<script>
import httper from "../../api/http";
let geolocation;
export default {
  data() {
    return {
      product_id: "", // 上一页获取服务编号,默认为空
      booking_id: "", // 上一页获取预约状态的服务编号,默认为空
      package_id: "", //上一页获取的用户卡券id, 默认为空
      latitude: "", // 微信api获取用户当前纬度,默认为空22.51595
      longitude: "", // 微信api获取用户当前经度,默认为空113.3926
      isMap: true, // header-地图/列表状态,默认为true(暂弃
      page_size: 20, // 列表每页条数,默认为20
      storeList: [], // 接口获取服务商家列表,默认为空
      storePage: 1, // 服务商家列表当前页数,默认为1
      storeFlag: true, // 服务商家列表能否下拉分页,默认为true
      city: "", // 用户所在市区,默认为空中山市
      cityStatus: false, // 用户是否手动选择市区,默认为false
      cityList: [
        "广州市",
        "韶关市",
        "深圳市",
        "珠海市",
        "汕头市",
        "佛山市",
        "江门市",
        "湛江市",
        "茂名市",
        "肇庆市",
        "惠州市",
        "梅州市",
        "汕尾市",
        "河源市",
        "阳江市",
        "清远市",
        "东莞市",
        "中山市",
        "潮州市",
        "揭阳市",
        "云浮市"
      ], // 接口获取市区列表
      isMaskHidden: true, // 是否隐藏遮盖层,默认为true
      buttonClicked: false, // 防止用户重复点击
      locationCount: 0, //地址请求次数
      loads: 0,
      wechatmesg: {}, //微信参数
      hrefurl: "", //当前页面url
      isLoading: true, //下拉刷新
      show: false,
      isYearInspection: false, //是否有年审服务
      product_name: "",
      product_type: "",
      inputkeyword: "",//搜索
    };
  },
  created() {
    this.getwechat({
      url: location.href.split('#')[0]
    })
    // 上一页获取服务编号
    if (this.$route.query.product_id) {
      this.product_id = Number(this.$route.query.product_id);
    } else {
      this.product_id = "";
    }
    //上页面获取商品服务名称
    if (this.$route.query.product_name) {
      this.product_name = this.$route.query.product_name;
    } else {
      this.product_name = "";
    }
    //上页面获取商品服务类型
    if (this.$route.query.product_type) {
      this.product_type = this.$route.query.product_type;
    } else {
      this.product_type = "";
    }
    console.log("this.$route.query.product_type)", this.$route.query.product_type)
    // 上一页获取预约状态的服务编号
    if (this.$route.query.booking_id) {
      this.booking_id = Number(this.$route.query.booking_id);
    } else {
      this.booking_id = "";
    }
    //上一页获取的用户卡券id
    if (this.$route.query.package_id) {
      this.package_id = Number(this.$route.query.package_id);
    } else {
      this.package_id = "";
    }
    if (this.$route.query.isYearInspection) {
      this.isYearInspection = this.$route.query.isYearInspection;
    } else {
      this.isYearInspection = "";
    }
    // geolocation = new qq.maps.Geolocation("AF6BZ-EP5KD-4HF46-PXR7T-6XLCK-RVFG6", "tom");
    geolocation = new qq.maps.Geolocation("444BZ-Z34R4-II6UD-DA3KR-P72IF-46FXB", "wechat-map");
    // this.hrefurl = window.location.href
    // this.request("getWechat", {
    //   url: this.hrefurl
    // })
    if (!sessionStorage.getItem("latitude") || !sessionStorage.getItem("longitude") || !sessionStorage.getItem("city")) {
      // this.getMyLocation()
      this.getWxLocation()
      return
    }
    //获取纬度
    if (sessionStorage.getItem("latitude")) {
      this.latitude = sessionStorage.getItem("latitude")
    }
    //获取经度
    if (sessionStorage.getItem("longitude")) {
      this.longitude = sessionStorage.getItem("longitude")
    }
    //获取城市
    if (sessionStorage.getItem("city")) {
      this.city = sessionStorage.getItem("city")
    }

    let requestData = {};
    requestData.product_id = this.product_id;
    requestData.lat = this.latitude;
    requestData.lng = this.longitude;
    requestData.city = this.city;
    requestData.page = this.storePage;
    requestData.page_size = this.page_size;
    this.request("getStoreList", requestData);
  },
  mounted() { },
  methods: {
    pageReturn() {
      this.$router.go(-1)
    },
    pageToIndex() {
      this.$router.push({
        path: "/"
      })
    },
    //搜索
    search() {
      let that = this
      that.pages = 1
      that.storeList = []
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      requestData.keyword = this.inputkeyword;
      that.request("getStoreList", requestData)
    },
    //显示城市列表
    showCityList() {
      this.isMaskHidden = true
    },
    //关闭城市列表
    closeCityList() {
      this.isMaskHidden = false
    },
    //显示地图
    showPopup() {
      this.show = true;
    },
    //获取微信配置信息接口
    getwechat(requestData = {}) {
      console.log('getwechat 1')
      httper.get("wechat/wechat/sign-package", requestData, res => {
        console.log(res);
        //wx.ready(() => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
        });
      })

      //});
    },
    getWxLocation() {
      let that = this
      wx.ready(() => {
        console.log('wx ready', "yes")
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            console.log("wx.getLocation", res)
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            var speed = res.speed; // 速度，以米/每秒计
            var accuracy = res.accuracy; // 位置精度
            that.latitude = latitude;
            that.longitude = longitude;
            sessionStorage.setItem("latitude", latitude)
            sessionStorage.setItem("longitude", longitude)
            var geocoder = new qq.maps.Geocoder();
            var latLng = new qq.maps.LatLng(latitude, longitude);
            //设置服务请求成功的回调函数
            geocoder.setComplete(function (result) {
              console.log(result.detail);
              that.city = result.detail.addressComponents.city
              sessionStorage.setItem("city", result.detail.addressComponents.city)
            });
            //若服务请求失败，则运行以下函数
            geocoder.setError(function () {

            });
            //对指定经纬度进行解析
            geocoder.getAddress(latLng);
            let requestData = {};
            requestData.product_id = that.product_id;
            requestData.lat = that.latitude;
            requestData.lng = that.longitude;
            requestData.city = that.city;
            requestData.page = that.storePage;
            requestData.page_size = that.page_size;
            that.request("getStoreList", requestData);
            console.log('getStoreList requestData 2', requestData)
          }
        });
      });
    },
    //下拉刷新
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功');
        this.isLoading = false;
        let requestData = {};
        requestData.product_id = this.product_id;
        requestData.lat = this.latitude;
        requestData.lng = this.longitude;
        requestData.city = this.city;
        requestData.page = this.storePage;
        requestData.page_size = this.page_size;
        this.request("getStoreList", requestData);
      }, 1000);
    },
    //获取城市定位
    tap(city) {
      this.city = city;
      this.storePage = 1;
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.city = this.city;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.storeList = []
      this.request("getStoreList", requestData);
    },
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },

    fadeIn(opacity = 1, param = "fadeIn") {
      let animation = wx.createAnimation({
        duration: 800, // 动画持续时间，单位ms
        timingFunction: "ease" // 动画以低速开始，然后加快，在结束前变慢
      });
      animation.opacity(opacity).step();
      let json = '{"' + param + '":""}';
      json = JSON.parse(json);
      json[param] = animation.export();
      this.setData(json);
    },
    fadeUp(px = -300, opacity = 1, param = "fadeUp") {
      let animation = wx.createAnimation({
        duration: 800,
        timingFunction: "ease"
      });
      animation
        .translateY(px)
        .opacity(opacity)
        .step();
      let json = '{"' + param + '":""}';
      json = JSON.parse(json);
      json[param] = animation.export();
      this.setData(json);
    },
    getMyLocation() {
      let that = this;
      var geolocation = new qq.maps.Geolocation(
        "AU7BZ-U52KD-Q5B4P-H46MS-WID3K-SZBRZ",
        "anhutong-web"
      );
      geolocation.getLocation(that.showPosition, that.showErr); //或者用getLocation精确度比较高
    },
    showPosition(position) {
      this.latitude = position.lat;
      this.longitude = position.lng;
      this.city = position.city;
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    },
    showErr(e) {
      // this.locationCount++
      // if (this.locationCount < 5) {
      //   // this.searchLocation(); //定位失败再请求定位
      this.getMyLocation() //定位失败再请求定位
      // } else {
      //   this.city = '定位失败,手动选择';
      // }

    },
    // scroll-view组件滚动到底部/右边时触发(待测试)
    scrolltolower() {
      let requestData = {
        product_id: this.product_id,
        lat: this.latitude,
        lng: this.longitude,
        page: this.storePage,
        page_size: this.page_size
      };
      if (this.cityStatus) requestData.city = this.city;
      this.request("getStoreList", requestData);
    },
    // 如果没有预约状态的服务编号,跳转服务商家详情页.反之跳转店铺详情
    toDesc(storeId) {
      console.log("protype", this.product_type)
      let that = this;
      if (that.isYearInspection) {
        if (this.product_name == '预约年检') {
          this.$router.push({
            path: "/appointmentYearInsp",
            query: {
              store_id: storeId,
              product_id: that.product_id,
              product_name: that.product_name,
              product_type: that.product_type
            }
          })
        } else {
          this.$router.push({
            path: "/yearlyInspection",
            query: {
              store_id: storeId,
              product_id: this.product_id,
              product_name: that.product_name,
              product_type: that.product_type
            }
          })
        }

      } else {
        if (that.booking_id) {
          that.$router.push({
            path: "/serviceDesc",
            query: {
              store_id: storeId,
              product_id: that.product_id,
              // booking_id: that.booking_id,
              package_id: that.package_id
            }
          });
        } else {
          that.$router.push({
            path: "/serviceDesc",
            query: {
              store_id: storeId
            }
          });
        }
      }
    },
    showMask(status = true, length = 300) {
      this.buttonClickedFun.call(this, 500).then(() => {
        console.log(status);
        switch (status) {
          case true:
            this.fadeIn.call(this);
            setTimeout(() => {
              this.isMaskHidden = false;

              // this.fadeUp.call(this, Number(0 - length), 1);
            }, 800);
            break;
          case false:
            this.fadeIn.call(this, 0);
            fadeUp.call(this, length, 0);
            setTimeout(() => {
              this.isMaskHidden = true;
            }, 800);
        }
      });
    },
    // 展示/隐藏遮盖层
    showMask1() {
      this.isMaskHidden = !this.isMaskHidden;
      if (this.isMaskHidden) {
        // this.showMask.call(that, true, -300);
      } else {
        // this.showMask.call(that, false, -300);
      }
    },
    // 改变市区
    changeCity(city) {
      let that = this;
      let requestData = {};
      that.city = city;
      that.storeList = [];
      that.storePage = 1;
      that.storeFlag = true;
      that.cityStatus = true;

      requestData.product_id = that.product_id;
      requestData.city = city;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.page = 1;
      requestData.page_size = that.page_size;
      that.request("getStoreList", requestData);
      if (this.isMaskHidden) {
        this.showMask.call(that, true, -300);
      } else {
        this.showMask.call(that, false, -300);
      }
    },
    request(type = "", requestData = {}) {
      let that = this;
      let data = {};
      switch (type) {
        // 调用高德api获取所在市
        // case 'getCity':
        //   var geolocation = new qq.maps.Geolocation("AF6BZ-EP5KD-4HF46-PXR7T-6XLCK-RVFG6", "myapp");
        //   geolocation.getLocation(this.showPosition, this.showErr);
        //   showPosition(position) {
        //       console.log(position);
        //       this.latitude = position.lat;
        //       this.longitude = position.lng;
        //       this.city = position.city;
        //       console.log("经纬度以及城市", this.latitude, 'this.latitude', this.longitude, 'this.longitude', this.city,
        //         'this.city')
        //       this.setMap();
        //     },
        //     showErr() {
        //       console.log("定位失败");
        //       this.searchLocation(); //定位失败再请求定位，测试使用
        //     },
        // break
        // 获取城市列表
        case "getCityList":
          httper.get(
            "/index/city-list",
            requestData,
            res => {
              console.log("城市列表", res);
              // data.storeList = that.storeList
              // for (let i in res.data) data.storeList.push(res.data[i])
              if (res.data.length > 0) {
                that.cityList = res.data;
              }
            },
            false
          );
          break;
        //获取微信参数
        case "getWechat":
          httper.get(
            "/wechat/wechat/sign-package",
            requestData,
            res => {
              console.log("微信参数", res);
              this.wechatmesg = res
              console.log("wechatmesg", this.wechatmesg)

            }
          );
          break;
        // 获取订单信息列表
        case "getStoreList":
          httper.post("store/service-store-list", requestData, res => {
            that.loads = 1;
            console.log("res", res)
            if (res.code == 0 && res.data) {
              //let storeList = [];
              // if (this.target > 1) {
              //   storeList = that.storeList;
              // }
              console.log("length", res.data.length)
              let storeList = that.storeList;
              that.storeFlag = res.data.length - 20 === 0
              for (let i = 0; i < res.data.length; i++) {
                storeList.push(res.data[i]);
              }
              that.storeList = storeList;
              // for (let i = 0; i < res.data.length; i++) {
              //   storeList.push(res.data[i]);
              // }
              // that.storeList = storeList;
              // // that.storePage++;
              // that.storeFlag = res.data.length === that.page_size;
              // console.log("storeList", that.storeList);
            }
            // else {
            //   that.$toast({
            //     message: '暂无相关服务'
            //   })
            // }
          },
            false
          );
          break;
      }
    },
    getmore() {
      let that = this
      console.log("获取更多")
      if (!that.storeFlag) {
        this.$toast({
          message: '没有更多了'
        })
        return
      }
      let page = (that.storePage) + 1
      that.storePage = page
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    }
  }
};
</script>

<style scoped>
.serviceList_top {
  height: 185px;
  background: #FD8C00;
  width: 100%;
  padding: 0;
}

input::-webkit-input-placeholder {
  font-size: 12px;
}

.serviceList_dingwei {
  display: flex;
  align-items: center;
  width: 90%;
  padding: 20px;
}

.serviceList_dingweiicon {
  width: 20px;
  height: 20px;
}

.serviceList_dingweiname {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.serviceList_List {
  /* position: absolute;
    top: 150px; */
  position: relative;
  top: -85px;
  width: 100%;
}

.serviceList_box {
  display: flex;
  width: 90%;
  padding: 0 10px;
  box-sizing: border-box;
  margin: 0 20px;
  height: 107px;
  align-items: center;
  margin-top: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  border-radius: 8px;

}

.serviceList_img {
  /* width: 138px;
    height: 77px; */
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.serviceList_imgbox {
  width: 40%;
  height: 77px;
  border-radius: 4px;
  margin-right: 15px;
}

.serviceList_detail {
  width: 60%;
  display: flex;
  flex-direction: column;
}

.serviceList_name {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.serviceList_address {
  font-size: 12px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.serviceList_juli {
  display: flex;
  align-items: center;
}

.serviceList_juliicon {
  width: 20px;
  height: 20px;
}

.serviceList_julinum {
  font-size: 12px;
  font-weight: 400;
  color: #FD8C00;
}

/* mask */
.maskPanel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3001;
}

.panelTop {
  height: 50px;
  width: 100%;
}


.panelBottom {
  height: calc(100% - 50px);
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.maskCont {
  position: fixed;
  top: 130px;
  left: 50%;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
  transform: translateX(-50%);
  width: 90%;
  z-index: 3002;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.maskdiv {
  background-color: #fcfcfc;
  border-radius: 5px;
  height: 35px;
  background: rgba(200, 200, 200, 0.2);
  width: calc(33.3% - 5px);
  margin: 2.5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-last {
  margin-top: 20px;
  width: 100%;
  height: 40px;
  text-align: center;
  color: rgba(102, 102, 102, 1);
}

.serviceList_none {
  top: 40%;
}

.serviceListsearch_box {
  width: 100%;
  height: 35px;
  background-color: #fff;
  /* box-shadow:0px 5px 7px 2px rgba(187,187,187,0.3); */
  border-bottom: 1px solid #D2D2D2;
  margin-top: 1px;
  padding: 10px;
  display: flex;
  align-items: center;
}

.serviceListsearch_left {
  width: 85%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #EEEEEE;
  border-radius: 25px;
}

.serviceListsearch_icon {
  width: 15px;
  height: 15px;
  margin: 0 10px;
}

.serviceListsearch_input {
  border: none;
  font-size: 12px;
  /* width: 100%; */
  width: 87%;
  background-color: inherit;
  color: #000000;
}

.serviceListsearch_text {
  font-size: 12px;
  margin-left: 5px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/serviceList.vue